module.exports = __webpack_public_path__ + "static/media/icon_healthAndBeauty.310ad80c.svg";